"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function LampWall(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M4 3v6h1.5C6.341 9 7 8.341 7 7.5 7 5.027 9.027 3 11.5 3 13.972 3 16 5.027 16 7.5v2.687c1.157.418 2 1.52 2 2.813v.43c1.744.706 2.907 1.897 3.414 3.039C22.004 17.795 22 19 22 19v1h-5a2 2 0 1 1-4 0H8v-1.03c.005-.19.05-1.295.586-2.5.507-1.142 1.67-2.333 3.414-3.039v-.43c0-1.294.843-2.396 2-2.813V7.5C14 6.107 12.892 5 11.5 5A2.484 2.484 0 0 0 9 7.5C9 9.421 7.421 11 5.5 11H4v6H2V3h2zm11 9c-.566 0-1 .435-1 1v1.781l-.758.189c-1.695.424-2.417 1.387-2.828 2.311-.172.387-.115.426-.174.719h9.52c-.059-.293-.002-.333-.174-.719-.41-.924-1.132-1.887-2.828-2.311L16 14.781V13c0-.565-.435-1-1-1z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = LampWall;
